import AppointmentHistoryRow from "./AppointmentHistoryRow";

const AppointmentHistory = ({
  appointments,
  onView,
  onEdit,
  onUpdateStatus,
  onCancel,
}) => {
  return (
    <ul role="list" className="divide-y divide-ink-100">
      {appointments.map((appointment) => (
        <li key={appointment.id}>
          <AppointmentHistoryRow
            appointment={appointment}
            onView={onView}
            onEdit={onEdit}
            onUpdateStatus={onUpdateStatus}
            onCancel={onCancel}
          />
        </li>
      ))}
    </ul>
  );
};

export default AppointmentHistory;
